export default {
  agents: [],
  agentsTotalData: 0,
  agentDetailsData: null,
  agentFiltersData: null,
  agentOptionsData: null,
}